import EmphasisedBackground from "@components/emphasisedBackground/EmphasisedBackground";
import { transparentize } from "polished";
import styled from "styled-components";

import { getFocusBorderElement, T_BREAD, T_PLAIN_big, T_TITLE_2_2, T_TITLE_4 } from "../../global.style";

export const SettingsHeader = styled.div`
    ${T_TITLE_2_2};
`;

export const SettingTilesWrapper = styled.div<{ $colCount: number }>`
    container-type: inline-size;
    display: grid;
    grid-template-columns: repeat(${props => props.$colCount >= 4 ? 4 : props.$colCount}, minmax(150px, 260px));
    gap: 15px;
    margin-top: 24px;
    @container (max-width: 720px) {
        grid-template-columns: repeat(2, minmax(150px, 100%)) !important;
    }
`;

export const SettingsCard = styled.div<{ $selected?: boolean; }>`
    position: relative;
    border: 1px solid ${props => props.theme.C_FIELD_line};
    padding: 16px;
    border-radius: 5px;
    cursor: pointer;

    ${getFocusBorderElement({ offset: 2, keyboardOnly: true })};

    &:hover {
        border-color: ${props => props.theme.C_ACT_main};
    }

    ${props => props.$selected && `
        border-color: ${props.theme.C_ACT_main};
        box-shadow: 0px 0px 5px ${transparentize(0.95, props.theme.C_CUST_DASHBOARD_TILE_BORDER)};
        background-color: ${transparentize(0.5, props.theme.C_BG_menu)};
    `};
`;

export const TopText = styled.div`
    ${T_PLAIN_big};
`;

export const EmphasizedText = styled.div`
    font-size: 20px;
    font-weight: 800;
    margin-top: 15px;
`;

export const SubText = styled.div`
    ${T_BREAD};
`;

export const AdditionalSettings = styled.div`
    ${T_PLAIN_big};
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    margin-top: 20px;
    white-space: pre-wrap;
`;

export const AdditionalEmphasized = styled.div`
    ${T_TITLE_4};
`;

export const EmphasisedBackgroundStyled = styled(EmphasisedBackground)<{
    largeBottomPadding?: boolean;
}>`
    padding-bottom: ${props => props.largeBottomPadding ? "50px" : null};
    min-width: 490px;
    margin-bottom: 21px;
`;

export const CompanyTypeWrapper = styled.div`
    display: flex;
    gap: 20px;
    align-items: baseline;
`;

export const AccountedFromInfo = styled.div`
    display: inline-block;
    ${T_PLAIN_big};
`;
